import { createContext, FC, ReactNode, useState } from 'react';
import Turnstile from 'react-turnstile';

const TURNSTILE_DISABLE_KEY = '1x00000000000000000000AA';

type TurnstileData = {
  widgetId: string;
};

export const TurnstileContext = createContext<TurnstileData | null>(null);

type Props = {
  siteKey: string;
  children: ReactNode;
  enabled: boolean;
};
/**
 * @param enabled - Indica si debe estar habilitado la obtención de token de Turnstile.
 * En caso de que esté deshabilitado, se utiliza clave de prueba Turnstile que lo
 * deshabilita.
 * @param siteKey - clave de Turnstile.
 */
export const TurnstileProvider: FC<Props> = ({ siteKey, children, enabled }) => {
  const [widgetId, setWidgetId] = useState('');
  const key = enabled ? siteKey : TURNSTILE_DISABLE_KEY;

  return (
    <>
      <TurnstileContext.Provider value={{ widgetId }}>{children}</TurnstileContext.Provider>
      <Turnstile
        sitekey={key}
        refreshExpired={'manual'}
        onLoad={async (widgetId) => {
          setWidgetId(widgetId);
        }}
        style={{ display: 'none' }}
      />
    </>
  );
};
